var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmDelet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E3EFFF",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#F0F6FF",
    strokeOpacity: 0.7,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6551 38.809L35.407 21.0117C35.1102 20.504 34.6856 20.083 34.1755 19.7903C33.6654 19.4977 33.0876 19.3438 32.4996 19.3438C31.9115 19.3438 31.3337 19.4977 30.8236 19.7903C30.3136 20.083 29.889 20.504 29.5922 21.0117L19.3441 38.809C19.0561 39.3016 18.9043 39.8619 18.9043 40.4326C18.9043 41.0032 19.0561 41.5636 19.3441 42.0562C19.6377 42.5664 20.0616 42.9893 20.5726 43.2815C21.0835 43.5737 21.663 43.7248 22.2515 43.7191H42.7476C43.3358 43.7243 43.9148 43.5731 44.4253 43.2809C44.9357 42.9887 45.3594 42.566 45.6527 42.0562C45.9411 41.5638 46.0933 41.0035 46.0937 40.4329C46.0941 39.8623 45.9427 39.3018 45.6551 38.809ZM43.2176 40.6488C43.1699 40.73 43.1012 40.7968 43.0187 40.8422C42.9362 40.8876 42.8429 40.9098 42.7488 40.9066H22.2515C22.1574 40.9098 22.0642 40.8876 21.9817 40.8422C21.8992 40.7968 21.8304 40.73 21.7828 40.6488C21.7424 40.5831 21.721 40.5074 21.721 40.4302C21.721 40.3531 21.7424 40.2774 21.7828 40.2117L32.0308 22.4144C32.0816 22.3363 32.151 22.2721 32.2329 22.2277C32.3148 22.1832 32.4064 22.16 32.4996 22.16C32.5927 22.16 32.6844 22.1832 32.7663 22.2277C32.8481 22.2721 32.9176 22.3363 32.9683 22.4144L43.2152 40.2117C43.256 40.2772 43.2778 40.3527 43.2782 40.4299C43.2786 40.5071 43.2576 40.5828 43.2176 40.6488ZM31.0933 32.9379V29.1879C31.0933 28.8149 31.2415 28.4572 31.5052 28.1935C31.7689 27.9298 32.1266 27.7816 32.4996 27.7816C32.8725 27.7816 33.2302 27.9298 33.494 28.1935C33.7577 28.4572 33.9058 28.8149 33.9058 29.1879V32.9379C33.9058 33.3108 33.7577 33.6685 33.494 33.9322C33.2302 34.1959 32.8725 34.3441 32.4996 34.3441C32.1266 34.3441 31.7689 34.1959 31.5052 33.9322C31.2415 33.6685 31.0933 33.3108 31.0933 32.9379ZM34.3746 37.6254C34.3746 37.9962 34.2646 38.3587 34.0586 38.6671C33.8526 38.9754 33.5597 39.2157 33.2171 39.3576C32.8745 39.4995 32.4975 39.5367 32.1338 39.4643C31.7701 39.392 31.436 39.2134 31.1738 38.9512C30.9115 38.689 30.733 38.3549 30.6606 37.9912C30.5883 37.6274 30.6254 37.2504 30.7673 36.9078C30.9092 36.5652 31.1495 36.2724 31.4579 36.0664C31.7662 35.8603 32.1287 35.7504 32.4996 35.7504C32.9969 35.7504 33.4738 35.9479 33.8254 36.2995C34.177 36.6512 34.3746 37.1281 34.3746 37.6254Z",
    fill: "url(#paint0_linear_6540_16431)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6540_16431",
    x1: 18.9043,
    y1: 19.3438,
    x2: 43.1351,
    y2: 46.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDelet);
export default __webpack_public_path__ + "static/media/confirmDelet.647b1ab735b0c4bd2618d7551698abf8.svg";
export { ForwardRef as ReactComponent };